import axios from "axios";
import Config from "src/config";

const v1_actionListaFlows = (clienteId) => {
    
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/${clienteId}/flows`
    });
};

export default v1_actionListaFlows;
